module.exports = __webpack_public_path__ + "static/assets/202f9953101e280d92ff0d87911401ce.svg";